<template>
    <div class="add_sukikamo_list" :class="id">
        <div class="sukikamolist_sukikamo pc"><img src="../assets/images/sukikamolist.svg" alt="すきカモリスト"></div>
        <div class="tittle">保存するフォルダを選んでください</div>
        <div
                class="item"
                v-for="list_info in sukikamo_list"
                :key="list_info.id"
                @click="toggleFavorite(list_info.id)"
        >
            <div class="name_wrapper">
                <span class="folder_name">{{Util.sanitize.decode(list_info.name)}}</span>
                <span class="edit" @click.stop="renameFolder(list_info.id, list_info.name)"><img src="../assets/images/edit.svg" alt="edit"></span>
            </div>
            <span class="saved" v-if="current_sukikamo_list.includes(list_info.id)">保存済み</span>
        </div>
        <div class="plus_item" :class="{open: accordion_open}">
            <div class="add" @click="nameNewFolder">+ 新規フォルダを作成する</div>
            <div class="accordion">
                <div class="wrapper">
                    <div class="description">
                        {{edit_list_id === -1 ? '新しいフォルダの名前' : 'フォルダの名前を変更する'}}
                    </div>
                    <label><input type="text" v-model="folder_name" placeholder="フォルダ名を入力してください"></label>
                    <div class="buttons">
                        <div class="button cancel" @click="accordion_open = false">キャンセル</div>
                        <div class="button submit" @click="submitName">{{edit_list_id === -1 ? '作成' : '変更'}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from 'uuid'
    import { mapState, mapMutations } from 'vuex'
    import Util from '../assets/js/Util'
    import Ajax from '../assets/js/Ajax'

    export default {
        name: "AddSukikamoList",
        props: {
            photo_data: Object
        },
        data: () => ({
            id: `id_${uuidv4()}`,
            is_loading: false,
            accordion_open: false,
            folder_name: '',
            edit_list_id: -1,
            Util
        }),
        computed: {
            ...mapState(['user_data', 'sukikamo_list']),
            current_sukikamo_list: _this => _this.photo_data.favorite_list
        },
        mounted() {
            document.addEventListener('click', this.checkClickedThisElement);
            document.querySelectorAll('.favorite_path').forEach(el => {
                el.addEventListener('click', this.checkClickedThisElement);
            });
        },
        destroyed() {
            document.removeEventListener('click', this.checkClickedThisElement);
            document.querySelectorAll('.favorite_path').forEach(el => {
                el.removeEventListener('click', this.checkClickedThisElement);
            });
        },
        methods: {
            ...mapMutations(["setSukikamoList"]),
            checkClickedThisElement(e) {
                if( e.target.closest(`.${this.id}`) ) return;
                this.$emit('close');
            },
            async toggleFavorite(list_id) {
                if ( this.is_loading ) return;

                this.is_loading = true;
                if ( this.current_sukikamo_list.includes(list_id) ) {
                    await Ajax.removeSukikamoListItem(list_id, this.photo_data.photo_id);
                    const favorite_list = this.photo_data.favorite_list.filter(id => id !== list_id);
                    this.$set(this.photo_data, 'favorite_list', favorite_list)
                } else {
                    await Ajax.addSukikamoListItem(list_id, this.photo_data.photo_id);
                    const favorite_list = [list_id, ...this.photo_data.favorite_list];
                    this.$set(this.photo_data, 'favorite_list', favorite_list)
                }
                this.is_loading = false;
            },
            async submitName() {
                if ( this.is_loading || !this.folder_name ) return;

                this.is_loading = true;

                if (this.edit_list_id === -1) {
                    await Ajax.addSukikamoList(this.folder_name);
                } else {
                    await Ajax.updateSukikamoListName(this.edit_list_id, this.folder_name);
                }
                this.setSukikamoList( await Ajax.getSukikamoList() );

                this.is_loading = false;
                this.accordion_open = false;
            },
            nameNewFolder() {
                if ( this.accordion_open && this.edit_list_id === -1) return this.accordion_open = false;
                this.accordion_open = true;
                this.edit_list_id = -1;
                this.folder_name = '';
            },
            renameFolder(id, name) {
                this.accordion_open = true;
                this.edit_list_id = id;
                this.folder_name = name;
            }
        }
    }
</script>

<style scoped lang="scss">
    .add_sukikamo_list{
        position: relative;
        width: 250px;
        box-sizing: border-box;
        background-color: white;
        border-radius: 8px;
        white-space: nowrap;
        color: #826E67;
        font-size: 13px;
        border: solid 2px #826E67;
        z-index: 1;
        div {
            padding: 5px 0;
            box-sizing: border-box;
        }
        .tittle {
            background-color: #cba6a6;
            border-radius: 5px 5px 0 0;
            color: white;
            text-align: center;
        }
        .item{
            cursor: pointer;
            &:hover{ opacity: 0.8 }
            div{
                padding: 0;
            }
            .name_wrapper{
                display: flex;
                align-items: center;
                .folder_name{
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width: 100px;
                }
                .edit{
                    margin-left: 0.5rem;
                    &:hover{ opacity: 0.8 }
                    img{
                        position: relative;
                        top: -1px;
                        vertical-align: middle;
                    }
                }
            }
        }
        .item:not(:last-child) {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: dotted 2px #EADCDC;
            box-sizing: border-box;
            padding-left: 15px;
            padding-right: 10px;
            .saved {
                background-color: #ba8989;
                color: white;
                padding: 2px 10px;
                border-radius: 15px;
                margin-left: 10px;
            }
        }
        .plus_item {
            margin-top: -3px;
            background-color: #f1e7e7;
            border-radius: 0 0 5px 5px;
            box-sizing: border-box;
            padding-left: 15px;
            cursor: pointer;
            &:not(.open):hover{ opacity: 0.8 }
            .add{
                padding: 0;
            }
            .accordion{
                padding: 0;
                visibility: hidden;
                max-height: 0;
                transition: 0.3s ease-in-out;
                overflow: hidden;
                .wrapper{
                    padding: 5px 10px 0 0;
                }
                label{
                    input{
                        width: 100%;
                        padding: 5px;
                        box-sizing: border-box;
                        border-radius: 5px;
                        border: 1px solid #CEC8CA;
                        &::placeholder{
                            color: #aaaaaa;
                            font-size: 12px;
                        }
                    }
                }
                .buttons{
                    padding: 10px 0 5px;
                    display: flex;
                    justify-content: space-around;
                    .button{
                        width: 40%;
                        border: 1px solid #CEC8CA;
                        text-align: center;
                        border-radius: 5px;
                        &.cancel{
                            background-color: white;
                        }
                        &.submit{
                            background-color: #BC8987;
                            color: white;
                        }
                    }
                }
            }
            &.open .accordion{
                visibility: visible;
                max-height: 200vh;
            }
        }
        .sukikamolist_sukikamo {
            position: absolute;
            top: -30px;
            right: -43px;
        }

    }
    @media screen and (max-width:639px) {
        .add_sukikamo_list{
            border-radius: 3px;
            .tittle {
                border-radius: 2px 2px 0 0;
            }
            .plus_item {
                border-radius: 0 0 2px 2px;
            }
        }
    }
</style>
